import { window } from '../window.js';

import '../controls/error_dialog.js';

const errorDescriptions = {
  'lost-connection-error': {
    title: 'No connection',
    message: `The service is temporarily unavailable, please try again later.
If the problem persists, please reach us at <a href="mailto:support@camperaid.com">support@camperaid.com</a>`,
  },
  'no-loc-error': {
    title: `Location not found`,
    message: `Weird, but no location was found. It could have been deleted or it is not public.`,
  },
  'pic-upload-error': {
    title: `Failed to upload an image`,
    message: `We work towards to fix it. In the meantime please consider to upload another image.`,
  },
  'pic-shrink-error': {
    title: `Failed to shrink an image`,
    message: `Image size is too big. Please try to upload another image of a smaller size.`,
  },
  'session-timeout': {
    title: `Session timeout`,
    message: `You have been inactive for some time. Please log in again.`,
    button: 'Log in',
  },
};

function reportError(id, callback = null) {
  let dialog = window.document.getElementById(id);
  if (!dialog) {
    const { button, message, title } = errorDescriptions[id];
    dialog = window.document.createElement('error-dialog');
    dialog.id = id;
    dialog.title = title;
    dialog.message = message;
    if (button) {
      dialog.buttonLabel = button;
    }
    dialog.onhide = callback;
    window.document.body.append(dialog);
  }
  dialog.show();
}

const reportLostConnectionError = () => reportError('lost-connection-error');
const reportNoLocError = callback => reportError('no-loc-error', callback);
const reportPicUploadError = () => reportError('pic-upload-error');
const reportPicShrinkError = () => reportError('pic-shrink-error');
const reportSessionTimeout = callback =>
  reportError('session-timeout', callback);

export {
  errorDescriptions,
  reportLostConnectionError,
  reportNoLocError,
  reportPicUploadError,
  reportPicShrinkError,
  reportSessionTimeout,
};
